import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n';
import App from './App';
import './styles/global.scss';
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/react"

// Performance monitoring
const reportWebVitals = async (onPerfEntry) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    const { getCLS, getFID, getFCP, getLCP, getTTFB } = await import('web-vitals');
    getCLS(onPerfEntry);
    getFID(onPerfEntry);
    getFCP(onPerfEntry);
    getLCP(onPerfEntry);
    getTTFB(onPerfEntry);
  }
};

// Create root element
const root = ReactDOM.createRoot(document.getElementById('root'));

// Render app based on environment
if (import.meta.env.PROD) {
  // Import ErrorBoundary synchronously to avoid loading screen
  import('./components/ErrorBoundary').then(({ default: ErrorBoundary }) => {
    root.render(
      <React.StrictMode>
        <ErrorBoundary>
          <App />
          <Analytics />
          <SpeedInsights />
        </ErrorBoundary>
      </React.StrictMode>
    );
  });
} else {
  root.render(
    <React.StrictMode>
      <App />
      <Analytics />
      <SpeedInsights />
    </React.StrictMode>
  );
}

// Report web vitals in production
if (import.meta.env.PROD) {
  reportWebVitals(console.log);
}

// Enable PWA in production
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then(registration => {
        console.log('SW registered:', registration);
      })
      .catch(registrationError => {
        console.log('SW registration failed:', registrationError);
      });
  });
}
